<template>
	<div>
		<Header />
		<AboutUs />
		<Services />
		<OurBeliefs />
		<Verse />
		<Missions />
		<Prayer />
		<Location />
		<Footer />
	</div>
</template>

<script>

import Header from './Header.vue'
import AboutUs from './AboutUs.vue'
import Services from './Services.vue'
import OurBeliefs from './OurBeliefs.vue'
import Verse from './Verse.vue'
import Missions from './Missions.vue'
import Prayer from './Prayer.vue'
import Location from '../../components/Location.vue'
import Footer from '../../components/Footer.vue'

export default {
  name: 'Index',
  components: { Header, AboutUs, Services, OurBeliefs, Verse,  Missions, Prayer, Location, Footer }
}
</script>
